import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, GoogleButton } from "@/components/AuthShell";
import { formatApiErrorDetail } from "@/lib/api";

export function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await register(name, email, password);
      navigate("/test", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  const inputCls =
    "w-full px-4 py-3.5 rounded-2xl bg-[#2A0A1B] border border-[#E32C8C]/35 bw-card text-[#F6DCEA] placeholder:text-[#EAC6D9]/60 focus:outline-none focus:border-[#E32C8C] transition-all";

  return (
    <AuthShell title="Inizia da te" subtitle="Crea il tuo account e fai il test">
      <form onSubmit={submit} className="space-y-3">
        <input
          type="text" value={name} onChange={(e) => setName(e.target.value)}
          placeholder="Il tuo nome" required data-testid="register-name-input" className={inputCls}
        />
        <input
          type="email" value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="Email" required data-testid="register-email-input" className={inputCls}
        />
        <input
          type="password" value={password} onChange={(e) => setPassword(e.target.value)}
          placeholder="Password (min 6 caratteri)" required minLength={6}
          data-testid="register-password-input" className={inputCls}
        />
        {error && <p className="text-sm text-[#FF7AB8] text-center" data-testid="register-error">{error}</p>}
        <button
          type="submit" disabled={busy} data-testid="register-submit-btn"
          className="w-full bg-gradient-to-r from-[#E32C8C] to-[#8E1A52] text-white font-semibold py-3.5 px-6 rounded-full shadow-lg shadow-[#E32C8C]/25 bw-glow hover:opacity-95 active:scale-[0.98] transition-all disabled:opacity-60"
        >
          {busy ? "Creazione…" : "Crea account"}
        </button>
      </form>

      <div className="flex items-center gap-3 my-5">
        <div className="flex-1 h-px bg-[#6B2247]" />
        <span className="text-xs text-[#EAC6D9]">oppure</span>
        <div className="flex-1 h-px bg-[#6B2247]" />
      </div>
      <GoogleButton testId="google-register-btn" />

      <p className="text-center text-sm text-[#EAC6D9] mt-6">
        Hai già un account?{" "}
        <Link to="/login" data-testid="go-login-link" className="text-[#E32C8C] font-semibold underline">
          Accedi
        </Link>
      </p>
    </AuthShell>
  );
}
